import './CSS/App.css';
import NavBar from './components/Navbar'
import Profile_Page from './components/Profile_Page'
import Booking_Page from './components/Booking_Page'
import AppointmentPage from './components/AppointmentPage'
import UserDashboard from './components/UserDashboard'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import React from 'react'
import Login_SignUp from './components/LoginPage';
import Depression_test from './components/Depression_test';
import Take_Test from './components/Take_Test';
import Q1 from './components/Questions/Q1.jsx';
import Select_Cate from './components/Select_Cate';
import SelectModeSession from './components/SelectModeSession';
import HomePage from './components/HOME/HomePage';
import ReviewBooking from './components/ReviewBooking';
import AboutTheCoun from './components/AboutTheCoun';
import TestResult from './components/TestResult';
import HomePageNew from './components/HomePageNew';
import Calendar from './components/Calendar';
import TypesOfTest from './components/TypesOfTest';
import CounsellorsHome from './components/CounsellorsDashBoared/CounsellorsHome';
import PreviousSessions from './components/CounsellorsDashBoared/PreviousSessions';
import ReqSession from './components/CounsellorsDashBoared/ReqSession';
import UpcomingSession from './components/CounsellorsDashBoared/UpcomingSession';
import TodaySession from './components/CounsellorsDashBoared/TodaySession';


function App() {
  
  return (
    <div className="App">
      <Router>
          <div className="App">
            <Switch>
              <Route exact path='/'>
                <NavBar />
                <HomePageNew/>
              </Route>
              <Route exact path='/dashboard'>
                <NavBar />
                <HomePage />
              </Route>
              <Route exact path='/depression_testHome'>
                <NavBar />
                <Depression_test/>
              </Route>
              <Route exact path='/Counsellors_page'>
                <NavBar />  
                <UserDashboard/>
              </Route>
              <Route exact path='/Booking_Page'>
                <NavBar />
                <Booking_Page/>
              </Route>
              <Route exact path='/AppointmentPage'>
                <NavBar />  
                <AppointmentPage/>
              </Route>
              <Route exact path='/Profile_Page'>
                <NavBar />
                <Profile_Page/>
              </Route>
              <Route exact path='/UserDashboard'>
                <NavBar />  
                <UserDashboard/>
              </Route>
              <Route exact path='/depression_test'>
                <NavBar />
                <Depression_test/>
              </Route>
              <Route exact path='/typeofTest'>
                <NavBar />
                <TypesOfTest/>
              </Route>
              <Route exact path='/take_test'>
                <Take_Test/>
              </Route>
              <Route exact path='/login_Signup'>
                <Login_SignUp />
              </Route>
              <Route exact path='/Q1'>
                <NavBar />
                <Q1/>
              </Route>
              <Route exact path='/select_category'>
                <Select_Cate/>
              </Route>
              <Route exact path='/select_mode'>
                <NavBar /> 
                <SelectModeSession/>
              </Route>
              <Route exact path='/review_booking'>
                <NavBar />
                <ReviewBooking/>
              </Route>
              <Route exact path='/aboutCounsellor'>
                <NavBar />
                <AboutTheCoun/>
              </Route>
              <Route exact path='/test_result'>
                <NavBar />
                <TestResult/>
              </Route>
             
              <Route exact path='/calendar'>
                <NavBar />
                <Calendar/>
              </Route>
              <Route exact path='/counsellorsHome'>
                <NavBar />
                <CounsellorsHome/>
              </Route>
              <Route exact path='/previousSessions'>
                <NavBar />
                <PreviousSessions/>
              </Route>
              <Route exact path='/reqSession'>
                <NavBar />
                <ReqSession/>
              </Route>
              <Route exact path='/upcomingSession'>
                <NavBar />
                <UpcomingSession/>
              </Route>
              <Route exact path='/todaySession'>
                <NavBar />
                <TodaySession/>
              </Route>
            </Switch>
          </div>
      </Router>
    </div>
  );
}

export default App;
